import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {LoginComponent} from "./pages/login/login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxsModule, NgxsModuleOptions} from "@ngxs/store";
import {environment} from "../environments/environment";
import {AuthState} from "./states/auth.state";
import {NgxsRouterPluginModule} from "@ngxs/router-plugin";
import {NgxsReduxDevtoolsPluginModule} from "@ngxs/devtools-plugin";
import {NgxsResetPluginModule} from "ngxs-reset-plugin";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {RouterModule} from "@angular/router";
import {AccountState} from "./states/account.state";
import {SweetAlert2Module} from "@sweetalert2/ngx-sweetalert2";
import {CommonModule, registerLocaleData} from "@angular/common";
import {ForgotPasswordComponent} from "./pages/forgot-password/forgot-password.component";
import {JwtInterceptor} from "./core/interceptors/jwt.interceptor";
import {NgbDateAdapter, NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {ChequeState} from "./states/cheque.state";
import {MastersState} from "./states/masters.state";
import {HeaderComponent} from "./components/header/header.component";
import {FooterComponent} from "./components/footer/footer.component";
import {UserBankState} from "./states/bank.state";
import {UserProfileState} from "./states/user-profile.state";
import {LoaderComponent} from "./components/loader/loader.component";
import {LoaderInterceptor} from "./core/interceptors/loader.interceptor";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgxSliderModule} from "@angular-slider/ngx-slider";
import {HttpErrorInterceptor} from "./core/interceptors/http-error-interceptor";
import {ToastState} from "./states/toast.state";
import {ToastrModule} from "ngx-toastr";
import {NgbLuxonDateFormatter} from "./util/ngb-luxon-date-formatter.service";
import {NgbLuxonDateAdapter} from "./util/ngb-luxon-date-adapter.service";

import localeEsAR from '@angular/common/locales/es-AR';
import {ClickableToast} from "./components/clickable-toast/clickable-toast";
import {OfertaState} from "./states/ofertas.state";
import {MessageState} from "./states/message.state";
import {OrderState} from "./states/order.state";
import {MovimientoState} from "./states/movimiento.state";
import {TransaccionState} from "./states/transaccion.state";
import {IncrementLimitState} from "./states/increment-limit.state";
import {AvatarModule} from "ngx-avatars";
import {DashboardState} from "./states/dashboard.state";
import {ReferralState} from './states/referral.state';
import {ThankYouComponent} from './pages/thank-you/thank-you.component';
import {DiscountState} from './states/discount.state';
import { FinancingState } from './states/financing.state';
import { BillingState } from './states/billing.state';
import { NegotiationsState } from './states/negotiations.state';
import { FinancingRequestFormState } from './states/financing-request-form.state';
import { ComponentsModule } from "./components/components.module";
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { MainLayoutComponent } from './layout/main-layout-component/main-layout-component.component';
import { AuhtLayoutComponent } from './layout/auht-layout-component/auht-layout-component.component';
import {RegisterOriginService} from './service/register-origin.service';

registerLocaleData(localeEsAR);

/**
 * Captura los parámetros de campaña de la URL de entrada antes de que el router
 * navegue/redirija, para que sobrevivan a la navegación interna previa al alta.
 */
export function captureRegisterOriginFactory(registerOriginService: RegisterOriginService) {
  return () => registerOriginService.captureFromUrl();
}

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.production,
  selectorOptions: {
    // These Selector Settings are recommended in preparation for NGXS v4
    // (See above for their effects)
    suppressErrors: false,
    injectContainerState: false
  },
  compatibility: {
    strictContentSecurityPolicy: true
  },

};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    LoaderComponent,
    ClickableToast,
    ThankYouComponent,
    MainLayoutComponent,
    AuhtLayoutComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    NgxsModule.forRoot([
        AuthState,
        AccountState,
        ChequeState,
        MastersState,
        UserProfileState,
        UserBankState,
        ToastState,
        OfertaState,
        MessageState,
        OrderState,
        MovimientoState,
        TransaccionState,
        IncrementLimitState,
        DashboardState,
        ReferralState,
        DiscountState,
        FinancingState,
        NegotiationsState,
        BillingState,
        FinancingRequestFormState
    ], ngxsConfig),
    NgxsRouterPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({
        disabled: true
    }),
    NgxsResetPluginModule.forRoot(),
    NgbModule,
    NgSelectModule,
    NgxDatatableModule,
    NgxSliderModule,
    ToastrModule.forRoot(),
    AvatarModule,
    ComponentsModule,
    HugeiconsIconComponent
],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    {provide: NgbDateParserFormatter, useClass: NgbLuxonDateFormatter},
    {provide: NgbDateAdapter, useClass: NgbLuxonDateAdapter},
    {provide: LOCALE_ID, useValue: 'es-AR'},
    {provide: APP_INITIALIZER, useFactory: captureRegisterOriginFactory, deps: [RegisterOriginService], multi: true}
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}


